import React, { FunctionComponent } from "react";
import styled, { ThemeProvider } from "styled-components";
import { defaultTheme } from "../../theme";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import { RichText } from "prismic-reactjs";


const Wrapper = styled.div`
  // border-radius: ${props => props.theme.defaultBorderRadius};
  // border: darkgray 1px solid;
  // background-color: ${props => props.theme.colors.altBackground};
  max-width: 350px;
`;

const ImageWrapper = styled.div`
  max-height: 300px;
  overflow: hidden;
  max-width: 350px;
  border-radius: ${props => props.theme.defaultBorderRadius};

`;

const TextWrapper = styled.div`
    margin-top: 15px;
`

const AboutKinga: FunctionComponent = () => {

    const data = useStaticQuery<GatsbyTypes.AboutKingaQuery>(graphql`
        query AboutKinga {
            prismic {
                allO_mnies {
                    edges {
                        node {
                            image
                            text
                            imageSharp {
                                childImageSharp {
                                    fluid(srcSetBreakpoints: [480]) {
                                        sizes
                                        src
                                        srcSet
                                        base64
                                        presentationHeight
                                        presentationWidth
                                        aspectRatio
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    return (
        <ThemeProvider theme={defaultTheme}>
            <Wrapper>
                <h1>{"O mnie"}</h1>
                <ImageWrapper>
                    {data?.prismic?.allO_mnies?.edges && data.prismic.allO_mnies.edges[0]?.node?.imageSharp?.childImageSharp?.fluid &&
                    <Img fluid={data.prismic.allO_mnies.edges[0]?.node?.imageSharp?.childImageSharp?.fluid} />}
                </ImageWrapper>
                {data.prismic.allO_mnies.edges && <TextWrapper>{RichText.asText(data.prismic.allO_mnies.edges[0]?.node.text)}</TextWrapper>}
            </Wrapper>
        </ThemeProvider>
    );
};

export default AboutKinga;